module.exports = __webpack_public_path__ + "img/switch_banner_en.97210193.png";